export default __webpack_public_path__ + "static/media/service-thumb-precast-fireplace.d63bd4e5.jpg";